import React, { useState } from 'react'
import { Input } from '../Input'
import {ReactComponent as SearchSvg} from '../../assets/search.svg';
// import SearchSvg from '../../assets/search.svg';
import {ReactComponent as CrossSvg} from '../../assets/cross.svg';
// import CrossSvg from '../../assets/cross.svg';

export const Search = ({sets, titles, setSets}) => {

  const [localValue, setLocalValue] = useState(sets.value);
  let timer;
  const setSearchValueHandler = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    clearTimeout(timer); // Сбрасываем предыдущий таймер

    timer = setTimeout(() => {
        setSets({ ...sets, value: newValue });
    }, 300);
  };

  const setSearchTypeHandler = (e) => {
    setSets({...sets, type: e.target.value});
  }
  const resetSearchValueHandler = () => {
    setLocalValue('');
    setSets({...sets, value: ''});
  }
  return (
    <div className="search-container">
      <div className="search">
        <label htmlFor='order-search' className='search__search-svg'><SearchSvg width={22} height={22} /></label>
        <Input id='order-search' className='search__input' placeholder='поиск' value={localValue} changeHandler={setSearchValueHandler} />
        <label htmlFor='order-search' onClick={resetSearchValueHandler} className='search__cross-svg'><CrossSvg width={16} height={16} /></label>
      </div>
      <div className='search__search-by'>
        <span>Искать по</span>
        <select value={sets.type} onChange={setSearchTypeHandler}>
          <option className='dark-theme-bg0' key="all" value={'all'}>Всем</option>
          {titles.map(t => <option className='dark-theme-bg0' key={t.key} value={t.key}>{t.label}</option>)}
        </select>
      </div>
    </div>
  )
}
